import { colors } from 'components/styles/variables';
import PropTypes from 'prop-types';

function Hamburger({ className, onClick }) {
  return (
    <button
      onClick={onClick}
      className={`navbar-mobile-hamburger-button ${className}`}
      aria-label="Open the menu"
    >
      <div className="bar" />
      <div className="bar" />
      <div className="bar" />
      <style jsx>{`
        .navbar-mobile-hamburger-button {
          width: 100%;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          height: 20px;
          background: none;
          border: none;
          margin-top: 5px;
        }

        .bar {
          background-color: ${colors.G4};
          height: 1px;
          border-radius: 1px;
          width: 20px;
        }
      `}</style>
    </button>
  );
}

Hamburger.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func,
};

export default Hamburger;
